// import { base64URLEncode, sha256 } from "./sha256-base64-url-encode"
// import createCodeVerifier from './create-code-verifier'
import hashed from './hashed'
import getEncodedVerifierKey from './getEncodedVerifierKey'
// import { opendir } from "fs";

export default function authorize({
                                    redirect_uri,
                                    provider,
                                    grant_type,
                                    authorizationEndpoint,
                                    client_id,
                                    scopes,
                                    storage = sessionStorage
                                  }) {

  // const encodedVerifier = base64URLEncode(createCodeVerifier());
  storage.setItem(
      getEncodedVerifierKey(client_id),
      JSON.stringify({
        // encodedVerifier,
         redirect_uri
      })
  )

  const query = {
    client_id: client_id,
    response_type: 'code',
    redirect_uri,
    // code_challenge: encodedVerifier,
    scope: 'openid groups profile',
    grant_type:'authorization_code',
    
  }   

 
const url = `${ provider }${ authorizationEndpoint }?${ hashed(query) }`;
  // const url = `https://sso.mvwc.com/as/authorization.oauth2?response_type=code&client_id=vsn_msas_test&&redirect_uri=http://localhost:3000&grant_type=authorization_code`;
  window.location.replace(url);
}